export const RESTART_LOGIN = 'RESTART_LOGIN';
export const VALIDATE_CREDENTIALS_REQUESTED = 'VALIDATE_CREDENTIALS_REQUESTED';
export const VALIDATE_CREDENTIALS_FAILED = 'VALIDATE_CREDENTIALS_FAILED';
export const VALIDATE_CREDENTIALS_SUCCESS = 'VALIDATE_CREDENTIALS_SUCCESS';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const VALIDATE_TOKEN_REQUESTED = 'VALIDATE_TOKEN_REQUESTED';
export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';
export const VALIDATE_TOKEN_FAILED = 'VALIDATE_TOKEN_FAILED';
export const LOGOUT = 'LOGOUT';
export const REAUTH = 'REAUTH';
export const SIGNUP_REQUESTED = 'SIGNUP_REQUESTED';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS';
export const VERIFICATION_FAILED = 'VERIFICATION_FAILED';
export const VERIFICATION_REQUESTED = 'VERIFICATION_REQUESTED';
export const CONFIRM_PASSWORD_RESET_REQUESTED = 'CONFIRM_PASSWORD_RESET_REQUESTED';
export const CONFIRM_PASSWORD_RESET_SUCCESS = 'CONFIRM_PASSWORD_RESET_SUCCESS';
export const CONFIRM_PASSWORD_RESET_FAILED = 'CONFIRM_PASSWORD_RESET_FAILED';
export const SEND_RESET_EMAIL_REQUESTED = 'SEND_RESET_EMAIL_REQUESTED';
export const SEND_RESET_EMAIL_FAILED = 'SEND_RESET_EMAIL_FAILED';
export const SEND_RESET_EMAIL_SUCCESS = 'SEND_RESET_EMAIL_SUCCESS';
export const SET_RECAPTCHA_READY = 'SET_RECAPTCHA_READY';
export const SET_USER_ACCOUNT_TYPE = 'SET_USER_ACCOUNT_TYPE';
export const REFRESH_COGNITO_TOKEN_SUCCESS = 'REFRESH_COGNITO_TOKEN_SUCCESS';
export const SCHEDULE_COGNITO_REFRESH = 'SCHEDULE_COGNITO_REFRESH';
export const START_COGNITO_REFRESH = 'START_COGNITO_REFRESH';
export const SET_ACCOUNT_MANAGEMENT_REDIRECT = 'SET_ACCOUNT_MANAGEMENT_REDIRECT';

export const restartLogin = () => ({
  type: RESTART_LOGIN
});

export const validateCredentials = (email, password) => ({
  type: VALIDATE_CREDENTIALS_REQUESTED,
  email,
  password
});

export const validateCredentialsSuccess = (user, token) => ({
  type: VALIDATE_CREDENTIALS_SUCCESS,
  user,
  token
});

export const validateCredentialsFailed = error => ({
  type: VALIDATE_CREDENTIALS_FAILED,
  error
});

export const authSuccess = (user, token) => ({
  type: AUTH_SUCCESS,
  user,
  token
});

export const validateToken = token => ({
  type: VALIDATE_TOKEN_REQUESTED,
  token
});

export const validateTokenFailure = error => ({
  type: VALIDATE_TOKEN_FAILED,
  error
});

export const validateTokenSuccess = user => ({
  type: VALIDATE_TOKEN_SUCCESS,
  user
});

export const logout = () => ({
  type: LOGOUT
});

export const reauth = lastAction => ({
  type: REAUTH,
  lastAction
});

export const signUp = (email, password, firstName, lastName, token, optInMarketingEmail) => ({
  type: SIGNUP_REQUESTED,
  email,
  password,
  firstName,
  lastName,
  token,
  optInMarketingEmail
});

export const signUpFailed = error => ({
  type: SIGNUP_FAILED,
  error
});

export const signUpSuccess = email => ({
  type: SIGNUP_SUCCESS,
  email
});

export const recaptchaVerification = token => ({
  type: VERIFICATION_REQUESTED,
  token
});

export const verificationSuccess = () => ({
  type: VERIFICATION_SUCCESS
});

export const verificationFailed = error => ({
  type: VERIFICATION_FAILED,
  error
});

export const sendResetPasswordEmail = (email, token) => ({
  type: SEND_RESET_EMAIL_REQUESTED,
  email,
  token
});

export const sendResetPasswordEmailSuccess = () => ({
  type: SEND_RESET_EMAIL_SUCCESS
});

export const sendResetPasswordEmailFailed = error => ({
  type: SEND_RESET_EMAIL_FAILED,
  error
});

export const resetPassword = (password, token, resetToken, verificationCode) => ({
  type: CONFIRM_PASSWORD_RESET_REQUESTED,
  token,
  resetToken,
  password,
  verificationCode
});

export const resetPasswordSuccess = () => ({
  type: CONFIRM_PASSWORD_RESET_SUCCESS
});

export const resetPasswordFailed = error => ({
  type: CONFIRM_PASSWORD_RESET_FAILED,
  error
});

export const setRecaptchaReady = isReady => ({
  type: SET_RECAPTCHA_READY,
  payload: isReady
});

export const setUserAccountType = accountType => ({
  type: SET_USER_ACCOUNT_TYPE,
  accountType
});

export const refreshCognitoTokenSuccess = () => ({
  type: REFRESH_COGNITO_TOKEN_SUCCESS
});

export const scheduleCognitoRefresh = scheduleTime => ({
  type: SCHEDULE_COGNITO_REFRESH,
  scheduleTime
});

export const startCognitoRefresh = () => ({
  type: START_COGNITO_REFRESH
});

export const setAccountManagementRedirect = redirect => ({
  type: SET_ACCOUNT_MANAGEMENT_REDIRECT,
  redirect
});
